import useSWR from 'swr';
import { getCurrentUser } from '../../../utils/common.util';
import { useCustomMutation } from '../../../utils/useCustomMutation';
import { putMethod } from '../../../api/common';
import { Loading, Toggle } from 'carbon-components-react';

export function RecordInLedger({ isOpen }) {
  const school = getCurrentUser()?.school;

  const { data, mutate, isLoading } = useSWR(
    isOpen
      ? `daily-billing/retrieve-subscription?schoolId=${school?.id}`
      : null,
  );

  const recordDailyBillingInLedger = data?.result?.recordDailyBillingInLedger;

  const { trigger, isMutating, error } = useCustomMutation(
    `daily-billing/update-subscription-ledger-records`,
    (url, { arg }) => putMethod(url, arg),
  );

  const isRunning = isLoading || isMutating;
  return (
    <div
      className="mt-30 d-flex-space-between"
      style={{
        gap: '10px',
        alignItems: 'center',
      }}
    >
      <p>Record Daily Fee Billing in Ledger</p>
      <div
        style={{
          maxWidth: '100px',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
        }}
      >
        {isRunning ? (
          <Loading
            small={true}
            withOverlay={false}
            style={{ alignSelf: 'end', marginBottom: '4px' }}
          />
        ) : (
          <div style={{ marginTop: '-20px' }}>
            <Toggle
              size="md"
              id="recordDailyBillingInLedger"
              labelText=""
              labelA=""
              labelB=""
              toggled={recordDailyBillingInLedger}
              onToggle={(value) =>
                trigger(
                  {
                    schoolId: school?.id,
                    recordDailyBillingInLedger: value,
                  },
                  {
                    onSuccess: () => {
                      mutate();
                    },
                  },
                )
              }
            />
          </div>
        )}
        {error && <p className="text-14 mt-10 text-danger">{error.message}</p>}
      </div>
    </div>
  );
}
